import React from "react"
import PropTypes from "prop-types"
import Card from "../../common/components/Card"
import Image from "next/image"
import { Box, Heading } from "@chakra-ui/react"

const FeatureCard = ({
  title,
  featureKey,
  value,
  selectedValue,
  image,
  isDisabled,
  onChange,
  isEditing,
}) => {
  const isSelected = selectedValue === value
  return (
    <Card
      opacity={isSelected ? 1 : 0.65}
      variant={isDisabled ? null : "link"}
      width="100%"
      p={0}
      pt="100%"
      borderColor={
        isDisabled
          ? "brand.headingLineColor"
          : isSelected
          ? "brand.orangeColor"
          : "brand.blueColor"
      }
      borderWidth={isDisabled ? 1 : isSelected ? 2 : 1}
      onClick={() => {
        if (!isDisabled) {
          let newVal = selectedValue
          if (selectedValue === true) {
            newVal = !value
          }
          onChange(featureKey, newVal, isEditing)
        }
      }}
    >
      <Box
        display="flex"
        alignItems="center"
        flexDirection="column"
        position="absolute"
        top="0"
        left="0"
        right="0"
        bottom="0"
      >
        <Image layout="fill" objectFit="cover" alt={title} src={image} />
        <Heading
          position="absolute"
          bottom={0}
          textAlign={"center"}
          as="h6"
          fontSize={[8, "sm"]}
          size={["xs", "sm"]}
          variant="link"
        >
          {title}
        </Heading>
      </Box>
    </Card>
  )
}

export default FeatureCard
